export const timeSheetsListingRoutes = [
  {
    path: 'listing',
    name: 'time-sheets-listing',
    component: () => import(/* webpackChunkName: "time-sheets-listing" */ './TimeSheetsListing.vue')
  }
];
